"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextWrapper = exports.SwitchWrapper = exports.Icon = exports.ContentWrapper = exports.Background = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dsWeb = require("@olxbr/ds-web");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = (0, _styledComponents["default"])(_dsWeb.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100svh;\n  width: 100%;\n\n  @media screen and (min-width: 840px) {\n    height: 100%;\n  }\n"])));
var ContentWrapper = exports.ContentWrapper = (0, _styledComponents["default"])(_dsWeb.Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  z-index: -1;\n"])));
var TextWrapper = exports.TextWrapper = (0, _styledComponents["default"])(_dsWeb.Flex)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  z-index: 1;\n  background-color: var(--color-neutral-70);\n  padding: var(--spacing-1) var(--spacing-2) var(--spacing-1) var(--spacing-2);\n"])));
var Background = exports.Background = _styledComponents["default"].img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n"])));
var Icon = exports.Icon = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n"])));
var SwitchWrapper = exports.SwitchWrapper = (0, _styledComponents["default"])(_dsWeb.Flex)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: var(--color-neutral-80);\n  padding: var(--spacing-1) var(--spacing-2) var(--spacing-0-5) var(--spacing-2);\n  border-radius: var(--spacing-1) var(--spacing-1) 0 0;\n"])));